var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"$container",class:[
    _vm.$style.overlay,
    _vm.isOpen && _vm.$style['overlay--open'],
  ],on:{"click":event => event.target === _vm.$refs.$container && _vm.close()}},[_c('div',{class:[
      _vm.$style.content,
      _vm.windowsWidth <= 700 && _vm.$style.mobileOverlay
    ]},[_vm._m(0),_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.close,on:{"click":_vm.close}},[_c('deleteIcon')],1)
}]

export { render, staticRenderFns }